import { themePropDefs } from '../../theme-options';
const colorProp = {
    type: 'enum',
    values: themePropDefs.accentColor.values,
    default: undefined,
};
export { colorProp };
//# sourceMappingURL=color.prop.js.map